import { io } from 'socket.io-client';
import { BACKEND_API_DOMAIN } from 'utilities/constants';

const socket = io(BACKEND_API_DOMAIN);

export default socket;
